import React, { useContext } from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from '@fiverr-private/fiverr_context';
import SharedContext from '../../../../../shared/context';
import { PrivacyType } from '../../../../../shared/types/privacyType';
import Badge from '../../../../../shared/components/Badge';
import Avatar from '../../../../../shared/components/Avatar';

import './style.scss';

const createdByKey = 'collections_perseus.collection_page.header.created_by';

const CreatorInfo = ({ collection }) => {
    const { ownerType, privacyType } = collection;
    const { creator } = useContext(SharedContext);

    const { profilePhoto, username, fullName } = creator;

    const formatName = () => {
        if (privacyType === PrivacyType.PRIVATE && fullName) {
            return fullName;
        } else {
            return username;
        }
    };

    return (
        <div className="creator-info">
            <div className="profile-wrapper">
                <Avatar profilePhoto={profilePhoto} size={24} username={username} />
                <p className="username tbody-6">
                    <I18n k={createdByKey} params={{ name: formatName() }} />
                </p>
            </div>
            <Badge showPrivateLabel={false} ownerType={ownerType} privacyType={privacyType} />
        </div>
    );
};

CreatorInfo.propTypes = {
    collection: object,
};

const mapStateToProps = ({ collection }) => ({ collection });

export { CreatorInfo };
export default connect(mapStateToProps)(CreatorInfo);
